import { Characteristic } from 'features/product-info';
import { ViewsModels } from 'features/reviews';
import { ReviewsValidations } from 'utils/domain-specifics/reviews/validation';
import { BRAND_CHARACTERISTICS_KEY } from 'common/constants';

export const getBrandCharacteristic = (characteristics: Characteristic[] = []) => {
  const brandCharacteristics = characteristics.find(({ key }) => key === BRAND_CHARACTERISTICS_KEY);
  return brandCharacteristics?.value ?? '';
};

export const getAggregationRatings = (reviewTotalScore?: ViewsModels.ReviewScoreTotal) => {
  const totalScore = reviewTotalScore?.score ?? null;
  const reviewsCount = reviewTotalScore?.count ?? null;
  if (
    typeof totalScore === 'number' &&
    ReviewsValidations.isRatingValueValid(totalScore) &&
    typeof reviewsCount === 'number' &&
    ReviewsValidations.isNumberOfRatingsValid(reviewsCount) &&
    reviewsCount > 0
  ) {
    return {
      totalScore: totalScore?.toFixed(1),
      reviewsCount: reviewsCount?.toFixed(0),
    };
  }
};
